(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nugenyx-category-landing"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const target = event.target.closest('.nugenyx-category-landing [data-nugenyx-event]');
    if (!target) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: target.dataset.nugenyxEvent,
      destination_handle: target.getAttribute('href') || '',
      offer_location: 'category_landing'
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nugenyx-huel-homepage-v2"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const target = event.target.closest('.nugenyx-huel-v2 a');
    if (!target) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'nugenyx_home_click',
      module_name: 'huel_inspired_homepage',
      destination_handle: target.getAttribute('href') || '',
      offer_location: 'homepage'
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nugenyx-huel-homepage"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const target = event.target.closest('[data-nugenyx-event]');
    if (!target) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: target.dataset.nugenyxEvent,
      module_name: target.dataset.moduleName || '',
      destination_handle: target.getAttribute('href') || '',
      offer_location: 'homepage'
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nugenyx-loyalty-program-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bindRivoSignupTriggers = () => {
      document.querySelectorAll("[data-rivo-signup-trigger]").forEach((trigger) => {
        if (trigger.hasAttribute("data-rivo-signup-bound")) return;

        trigger.setAttribute("data-rivo-signup-bound", "true");
        trigger.setAttribute("aria-label", "Open Nugenyx Rewards sign up");

        trigger.addEventListener("click", (event) => {
          const launcher = document.querySelector("#launcher-wrapper .ba-met-handler, #launcher-wrapper");

          if (!(launcher instanceof HTMLElement)) return;

          event.preventDefault();

          if (typeof window.MouseEvent === "function") {
            ["mousedown", "mouseup", "click"].forEach((type) => {
              launcher.dispatchEvent(new MouseEvent(type, {
                bubbles: true,
                cancelable: true,
                view: window
              }));
            });
          } else {
            launcher.click();
          }

          window.setTimeout(() => {
            const widget = document.querySelector("#loy-widget-wrapper");
            const widgetIsOpen = widget instanceof HTMLElement && window.getComputedStyle(widget).display !== "none" && widget.getBoundingClientRect().width > 0;

            if (!widgetIsOpen) {
              window.location.href = trigger.href;
            }
          }, 700);
        });
      });
    };

    bindRivoSignupTriggers();
    setTimeout(bindRivoSignupTriggers, 400);
    setTimeout(bindRivoSignupTriggers, 1200);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nugenyx-product-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll(".nugenyx-pdp").forEach((page) => {
    const trustpilotWidgets = page.querySelectorAll(".trustpilot-widget");

    if (trustpilotWidgets.length) {
      const loadTrustpilotWidgets = () => {
        if (!window.Trustpilot) return;
        trustpilotWidgets.forEach((widget) => window.Trustpilot.loadFromElement(widget, true));
      };

      if (window.Trustpilot) {
        loadTrustpilotWidgets();
      } else if (!document.querySelector('script[data-nugenyx-trustpilot]')) {
        const script = document.createElement("script");
        script.async = true;
        script.dataset.nugenyxTrustpilot = "true";
        script.src = "https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
        script.addEventListener("load", loadTrustpilotWidgets);
        document.head.appendChild(script);
      }
    }

    page.querySelectorAll("[data-nugenyx-gallery]").forEach((gallery) => {
      const slides = Array.from(gallery.querySelectorAll("[data-gallery-panel]"));
      const thumbs = Array.from(gallery.querySelectorAll("[data-gallery-thumb]"));
      let activeIndex = 0;
      let startX = 0;

      const showSlide = (index) => {
        if (!slides.length) return;
        activeIndex = (index + slides.length) % slides.length;

        slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === activeIndex;
          slide.classList.toggle("is-active", isActive);
          slide.setAttribute("aria-hidden", isActive ? "false" : "true");
        });

        thumbs.forEach((thumb) => {
          const thumbSlideIndex = Number(thumb.getAttribute("data-gallery-thumb") || 0);
          const isActive = thumbSlideIndex === activeIndex;
          thumb.classList.toggle("is-active", isActive);
          thumb.setAttribute("aria-selected", isActive ? "true" : "false");
        });
      };

      thumbs.forEach((thumb) => {
        const thumbSlideIndex = Number(thumb.getAttribute("data-gallery-thumb") || 0);
        thumb.addEventListener("click", () => showSlide(thumbSlideIndex));
      });

      gallery.addEventListener("touchstart", (event) => {
        startX = event.touches[0]?.clientX || 0;
      }, { passive: true });

      gallery.addEventListener("touchend", (event) => {
        const endX = event.changedTouches[0]?.clientX || 0;
        const delta = endX - startX;
        if (Math.abs(delta) < 42) return;
        showSlide(delta < 0 ? activeIndex + 1 : activeIndex - 1);
      });
    });

    page.querySelectorAll("[data-qty-minus], [data-qty-plus]").forEach((button) => {
      button.addEventListener("click", () => {
        const input = button.parentElement.querySelector("input[name='quantity']");
        if (!input) return;
        const current = Number(input.value || 1);
        const next = button.hasAttribute("data-qty-plus") ? current + 1 : Math.max(1, current - 1);
        input.value = String(next);
      });
    });

    page.querySelectorAll(".nugenyx-pdp__option input").forEach((input) => {
      input.addEventListener("change", () => {
        page.querySelectorAll(".nugenyx-pdp__option").forEach((label) => label.classList.remove("is-selected"));
        input.closest(".nugenyx-pdp__option")?.classList.add("is-selected");
      });
    });

    const syncAppstleSellingPlans = () => {
      page.querySelectorAll(".nugenyx-pdp__form").forEach((form) => {
        const appstleMount = form.querySelector("[data-nugenyx-appstle]");
        const appstleInputs = Array.from(form.querySelectorAll(".appstle_sub_widget input[name='selling_plan'], .appstle_subscription_wrapper input[name='selling_plan'], #appstle-subscription-widget-placeholder input[name='selling_plan'], [class^='appstleSellingPlan'][name='selling_plan']"));
        const appstleWidget = form.querySelector(".appstle_sub_widget, .appstle_subscription_wrapper, #appstle-subscription-widget-placeholder");
        const appstleActive = Boolean(appstleWidget && appstleInputs.length);
        const fallback = form.querySelector("[data-nugenyx-selling-plan-fallback]");
        const fallbackInputs = fallback ? Array.from(fallback.querySelectorAll("input[name='selling_plan']")) : [];

        if (appstleMount) {
          appstleMount.classList.toggle("is-appstle-rendered", appstleActive);
        }
        form.classList.toggle("is-appstle-active", appstleActive);
        fallbackInputs.forEach((fallbackInput) => {
          fallbackInput.disabled = appstleActive;
        });
      });
    };

    syncAppstleSellingPlans();
    setTimeout(syncAppstleSellingPlans, 400);
    setTimeout(syncAppstleSellingPlans, 1200);

    const appstleObserver = new MutationObserver(syncAppstleSellingPlans);
    appstleObserver.observe(page, { childList: true, subtree: true });

    page.querySelectorAll(".nugenyx-pdp__form").forEach((form) => {
      form.addEventListener("submit", syncAppstleSellingPlans);
    });

    page.querySelectorAll("[data-variant-option]").forEach((input) => {
      input.addEventListener("change", () => {
        page.querySelectorAll(".nugenyx-pdp__variant").forEach((label) => label.classList.remove("is-selected"));
        input.closest(".nugenyx-pdp__variant")?.classList.add("is-selected");

        const price = input.getAttribute("data-price") || "";
        const compare = input.getAttribute("data-compare") || "";
        const available = input.getAttribute("data-available") === "true";
        const priceTarget = page.querySelector("[data-product-price]");
        const purchasePrice = page.querySelector("[data-purchase-price]");
        const stickyPrice = page.querySelector("[data-sticky-price]");
        const compareTarget = page.querySelector("[data-product-compare]");
        const submit = page.querySelector("[data-product-submit]");
        const submitText = page.querySelector("[data-product-submit-text]");
        const stickySubmit = page.querySelector("[data-sticky-submit]");

        if (priceTarget) priceTarget.textContent = price;
        if (purchasePrice) purchasePrice.textContent = price;
        if (stickyPrice) stickyPrice.textContent = price;

        if (compareTarget) {
          compareTarget.textContent = compare;
          compareTarget.classList.toggle("is-hidden", !compare);
        }

        if (submit) submit.disabled = !available;
        if (stickySubmit) stickySubmit.disabled = !available;
        if (submitText) submitText.textContent = available ? "Add to cart" : "Sold out";
        if (stickySubmit) stickySubmit.textContent = available ? "Add to cart" : "Sold out";
        syncAppstleSellingPlans();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nugenyx-rewards-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bindRivoSignupTriggers = () => {
      document.querySelectorAll("[data-rivo-signup-trigger]").forEach((trigger) => {
        if (trigger.hasAttribute("data-rivo-signup-bound")) return;

        trigger.setAttribute("data-rivo-signup-bound", "true");
        trigger.setAttribute("aria-label", "Open Nugenyx Rewards sign up");

        trigger.addEventListener("click", (event) => {
          const launcher = document.querySelector("#launcher-wrapper .ba-met-handler, #launcher-wrapper");

          if (!(launcher instanceof HTMLElement)) return;

          event.preventDefault();

          if (typeof window.MouseEvent === "function") {
            ["mousedown", "mouseup", "click"].forEach((type) => {
              launcher.dispatchEvent(new MouseEvent(type, {
                bubbles: true,
                cancelable: true,
                view: window
              }));
            });
          } else {
            launcher.click();
          }

          window.setTimeout(() => {
            const widget = document.querySelector("#loy-widget-wrapper");
            const widgetIsOpen = widget instanceof HTMLElement && window.getComputedStyle(widget).display !== "none" && widget.getBoundingClientRect().width > 0;

            if (!widgetIsOpen) {
              window.location.href = trigger.href;
            }
          }, 700);
        });
      });
    };

    bindRivoSignupTriggers();
    setTimeout(bindRivoSignupTriggers, 400);
    setTimeout(bindRivoSignupTriggers, 1200);
  })();

  } catch(e) { console.error(e); }
})();
})();
